<template>
  <ul class="tree">
    <node-tree :node="treeData"></node-tree>
  </ul>
</template>

<script>
import NodeTree from "./Node";

export default {
  props: {
    treeData: Object,
  },
  components: {
    NodeTree,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/products/category/Tree.vue